import React, { FC } from "react";
import { Link } from "react-router-dom";
import { FullPageChatLinkProps } from "@zeemee/react-web-chat";
import { useRoute } from "@/routes/getRoute";

export const FullPageChatLink: FC<FullPageChatLinkProps> = ({
  children,
  ...props
}) => {
  const getRoute = useRoute();
  return (
    <Link {...props} to={getRoute("chat")}>
      {children}
    </Link>
  );
};
